import { HttpParams } from '@angular/common/http';
import { ApiService } from '@libs/core/base-config';
import { omitUndefinedValues } from '@libs/core/lib/utils/utils';
import { Dtos, Entity, productReviewSchema, productReviewsListResponseSchema } from '@libs/mtjr/shared/generated/types';
import { map } from 'rxjs';

export function productReviewsList(
  apiService: ApiService,
  queryParams: Dtos.ProductReviewsListQueryParams,
  { productId }: Dtos.ProductReviewsListPathParams,
) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/product-reviews/product-reviews-list/${productId}`, { params })
    .pipe(map((data) => productReviewsListResponseSchema().parse(data)));
}

export function productReviewCreate(
  apiService: ApiService,
  { orderId, subOrderId, productId, rating, review }: Dtos.ProductReviewCreateBody,
) {
  return apiService.http
    .post(`${apiService.baseUrl}/api/v1/product-reviews/product-review-create`, {
      orderId,
      subOrderId,
      productId,
      rating,
      review,
    })
    .pipe(map((data) => productReviewSchema().parse(data)));
}

export function patchProductReview(
  apiService: ApiService,
  id: string,
  productReviewUpdate: Partial<Entity.ProductReviewUpdate>,
) {
  return apiService.http.patch<Dtos.UpdateResult>(
    `${apiService.baseUrl}/api/v1/product-reviews/${id}`,
    productReviewUpdate,
  );
}

export function deleteProductReview(apiService: ApiService, id: string) {
  return apiService.http.delete<void>(`${apiService.baseUrl}/api/v1/product-reviews/${id}`);
}
